function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { CSS_CLASSES, STRINGS } from './constants';
import { validateNodeType } from '../../global/js/util';

var Select =
/*#__PURE__*/
function () {
  _createClass(Select, null, [{
    key: "create",
    value: function create(element, options) {
      return this.instances.get(element) || new this(element, options);
    }
  }, {
    key: "createAll",
    value: function createAll() {
      var _this = this;

      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

      var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Finds all instances of select on the document or within a given element and instantiates them.
      var options = _objectSpread({
        initSelector: this.strings.INIT_SELECTOR
      }, _options);

      validateNodeType(target);
      var selects = Array.from(target.querySelectorAll(options.initSelector));
      selects.forEach(function (select) {
        return _this.create(select, options);
      });
    }
  }, {
    key: "cssClasses",
    get: function get() {
      return CSS_CLASSES;
    }
  }, {
    key: "strings",
    get: function get() {
      return STRINGS;
    }
  }]);

  function Select(root) {
    var _this2 = this;

    _classCallCheck(this, Select);

    _defineProperty(this, "onFocus", function () {
      _this2._root.classList.add(_this2.constructor.cssClasses.ACTIVE);
    });

    _defineProperty(this, "onBlur", function () {
      _this2._root.classList.remove(_this2.constructor.cssClasses.ACTIVE);
    });

    _defineProperty(this, "onChange", function () {
      _this2.assignClasses();
    });

    _defineProperty(this, "_getCurrentValueOptionElement", function () {
      return _this2._inputElement.options[_this2._inputElement.selectedIndex];
    });

    this._root = root;
    this._inputElement = this._root.querySelector(".".concat(this.constructor.cssClasses.EL__INPUT));

    if (!this._inputElement) {
      throw new Error("Select must have an input element with a class of .".concat(this.constructor.cssClasses.EL__INPUT));
    }

    this._bindEventListeners();

    this.assignClasses();
    this.constructor.instances.set(this._root, this);
  }

  _createClass(Select, [{
    key: "_bindEventListeners",
    value: function _bindEventListeners() {
      this._inputElement.addEventListener('focus', this.onFocus);

      this._inputElement.addEventListener('blur', this.onBlur);

      this._inputElement.addEventListener('change', this.onChange);
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      return this._inputElement.required;
    }
  }, {
    key: "value",
    value: function value() {
      // Current value of the Select
      return this._inputElement.value;
    }
  }, {
    key: "set",
    value: function set(value) {
      this._inputElement.value = value;

      this._inputElement.dispatchEvent(new Event('change'));
    }
  }, {
    key: "assignClasses",
    value: function assignClasses() {
      var option = this._getCurrentValueOptionElement();

      if (option && option.innerHTML) {
        if (option.dataset.rayPlaceholder) {
          this._root.classList.add(this.constructor.cssClasses.PLACEHOLDER_MODE);

          this._root.classList.remove(this.constructor.cssClasses.HAS_VALUE);
        } else {
          this._root.classList.add(this.constructor.cssClasses.HAS_VALUE);

          this._root.classList.remove(this.constructor.cssClasses.PLACEHOLDER_MODE);
        }
      } else {
        this._root.classList.remove(this.constructor.cssClasses.PLACEHOLDER_MODE, this.constructor.cssClasses.HAS_VALUE);
      }

      if (this.isRequired()) {
        this._root.classList.add(this.constructor.cssClasses.REQUIRED);
      } else {
        this._root.classList.remove(this.constructor.cssClasses.REQUIRED);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // Implement this method to release any resources / deregister any listeners they have
      // attached. An example of this might be deregistering a resize event from the window object.
      this._inputElement.removeEventListener('focus', this.onFocus);

      this._inputElement.removeEventListener('blur', this.onBlur);

      this._inputElement.removeEventListener('change', this.onChange);

      this.constructor.instances.delete(this._root);
    }
  }]);

  return Select;
}();

_defineProperty(Select, "instances", new WeakMap());

export default Select;